import { useEffect, useState } from 'react';

export const useOnWindowResize = (handler: (event: UIEvent) => void): void => {
  const isClient = typeof window === 'object';

  useEffect(() => {
    if (!isClient) {
      return;
    }

    window.addEventListener('resize', handler);

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [isClient, handler]);
};

type ResponsiveBreakpoints = {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  xxl: boolean;
  xxxl: boolean;
};

export function useReponsiveBreakpoints(): ResponsiveBreakpoints {
  const [width, setWidth] = useState(window.innerWidth);
  useOnWindowResize(() => {
    setWidth(window.innerWidth);
  });
  return {
    xs: true,
    sm: width >= 576,
    md: width >= 768,
    lg: width >= 992,
    xl: width >= 1200,
    xxl: width >= 1800,
    xxxl: width >= 2400,
  } as ResponsiveBreakpoints;
}
